import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type Iframe from './iframe.vue'

// 定义组件props
export const iframeProps = buildProps({
  // 嵌入页面的URL
  src: {
    type: String,
    default: '',
  },

  // 用于无障碍访问的标题
  title: {
    type: String,
    default: '内嵌页面',
  },

  // 宽度设置（支持px/%/vw等单位）
  width: {
    type: String,
    default: '100%',
  },

  // 高度设置（支持px/%/vh等单位）
  height: {
    type: String,
    default: '500px',
  },

  // 加载行为（eager/lazy）
  loadingType: {
    type: definePropType<'eager' | 'lazy'>(String),
    default: 'eager',
  },

  // 是否显示边框
  showBorder: {
    type: Boolean,
    default: false,
  },
} as const)

// props
export type IframeProps = ExtractPropTypes<typeof iframeProps>

// instance
export type IframeInstance = InstanceType<typeof Iframe>
